import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import { 
    LmSection_1,
    LmLlms,
    LmHowDoWeDoIt,
    LmDomainContext,
    LmCostEfficiency,
    LmCustomBuiltLlms
} from './component'
const LanguageModels = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                const elementTop = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementTop - 100,
                    behavior: 'smooth'
                });
            }
        }
        else{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);
    return (
        <>
            <section className="hero-area hero-area-background">
                <LmSection_1 />
            </section>
            <section className='mt-20'>
                <div className="container">
                    <div id="how-do-we-do-it">
                        <LmHowDoWeDoIt/>
                    </div>
                    <div id="domain-context">
                        <LmDomainContext/>
                    </div>
                    <div id="cost-effective">
                        <LmCostEfficiency/>
                    </div>
                    <div id="llms">
                       <LmCustomBuiltLlms/>
                    </div>
                </div>
            </section>
        </>
    )
}

export {LanguageModels}